import { type InstrumentWithMetadata } from "helpers/types/instruments/metadata"

export function getDownloadDataFileName(instrumentMetadata: InstrumentWithMetadata, isIntradayEnabled: boolean, latestPriceTimestamp: string | null) {
  const safeTimestamp = latestPriceTimestamp ? latestPriceTimestamp.replace(/:/g, "-") : ""
  return `Dashboard - ${instrumentMetadata?.name || instrumentMetadata?.id}${isIntradayEnabled ? "-Intraday" : ""}${safeTimestamp ? `-${safeTimestamp}` : ""}`
}

export const DOWNLOAD_SHEET_ORDER = {
  assets: 0,
  factors: 1,
  kpi: 2,
}
